import React, { useState } from "react";
import FormEditor from "./EditFormFields/FormEditor";
import UseToggle from "../../../Hooks/UseToggle";
import FormDataEntry from "./DataEntryManagement/FormDataEntry";
import ViewFormList from "./FormList/ViewFormList";
import ViewFormReportList from "./ReportManagement/FormReport/ViewFormReportList";
import FormFieldLibraryEditor from "../../Roles/AppsComponant/GlobalFormLibrary/FormEditor/FormFieldLibraryEditor";

const initialFormFields = [
  {
    type: "heading",
    fieldLabel: "Heading",
    fieldLabelType: false,
    labelBold: true,
    labelItalic: false,
    labelUnderline: false,
    labelColor: "#000000",
    columnSize: 12,
    labelSize: 16,
    fieldWidthSize: 100,
  },
  {
    type: "text",
    fieldLabel: "Text",
    fieldName: "TEXT",
    fieldPlaceholder: "Enter Your Text",
    fieldUnit: "no",
    fieldReview: "yes",
    fieldLabelType: false,
    fieldDerivation: "no",
    fieldFactor: "no",
    labelBold: true,
    labelItalic: false,
    labelUnderline: false,
    labelColor: "#000000",
    labelSize: 14,
    columnSize: 12,
    fieldWidthSize: 100,
    inputWidthSize: 100,
    manageTextLength: "no",
    fieldMandatory: "no",
    groupField: "no",
    customField: "no",
    conditionalIds: [],
  },
  {
    type: "date",
    fieldLabel: "Date",
    fieldName: "DATE",
    dayLabel: "Day",
    dayName: "D",
    monthLabel: "Month",
    monthName: "M",
    yearLabel: "Year",
    yearName: "Y",
    dateFormat: "DD_MM_YYYY",
    fieldReview: "yes",
    fieldLabelType: false,
    labelBold: true,
    labelItalic: false,
    labelUnderline: false,
    labelColor: "#000000",
    labelSize: 14,
    columnSize: 12,
    fieldWidthSize: 100,
    manageDateRange: "no",
    fieldMandatory: "no",
    groupField: "no",
    customField: "no",
    conditionalIds: [],
    fieldDerivation: "no",
    fieldFactor: "no",
  },
  {
    type: "time",
    fieldLabel: "Time",
    fieldName: "TIME",
    hourLabel: "Hour",
    hourName: "H",
    minuteLabel: "Minute",
    minuteName: "M",
    secondLabel: "Second",
    secondName: "S",
    timeFormat: "hhmmss",
    clockTimeFormat: "12",
    fieldReview: "yes",
    fieldLabelType: false,
    labelBold: true,
    labelItalic: false,
    labelUnderline: false,
    labelColor: "#000000",
    labelSize: 14,
    columnSize: 12,
    fieldWidthSize: 100,
    manageTimeRange: "no",
    fieldMandatory: "no",
    groupField: "no",
    customField: "no",
    conditionalIds: [],
    fieldDerivation: "no",
    fieldFactor: "no",
  },
  {
    type: "file",
    fieldLabel: "File",
    fieldName: "FILE",
    fieldReview: "yes",
    fieldLabelType: false,
    labelBold: true,
    fieldFileType: [{ label: "PDF File", value: "pdf" }],
    labelItalic: false,
    labelUnderline: false,
    labelColor: "#000000",
    labelSize: 14,
    columnSize: 12,
    fieldWidthSize: 100,
    inputWidthSize: 100,
    fieldMandatory: "no",
    customFieldRemark: "no",
    groupField: "no",
    customField: "no",
    conditionalIds: [],
  },
  {
    type: "dropdown",
    fieldLabel: "Dropdown",
    fieldName: "DROPDOWN",
    fieldReview: "yes",
    fieldLabelType: false,
    fieldDerivation: "no",
    fieldFactor: "no",
    labelBold: true,
    labelItalic: false,
    labelUnderline: false,
    labelColor: "#000000",
    labelSize: 14,
    columnSize: 12,
    fieldWidthSize: 100,
    inputWidthSize: 100,
    groupField: "no",
    customField: "no",
    customFieldRemark: "no",
    conditionalFields: [],
    conditionalIds: [],
  },
  {
    type: "range",
    fieldLabel: "Range",
    fieldName: "RANGE",
    fieldReview: "yes",
    fieldLabelType: false,
    fieldDerivation: "no",
    fieldFactor: "no",
    startRange: 0,
    endRange: 100,
    labelBold: true,
    labelItalic: false,
    labelUnderline: false,
    labelColor: "#000000",
    labelSize: 14,
    manageRange: "no",
    columnSize: 12,
    fieldWidthSize: 100,
    inputWidthSize: 100,
    fieldMandatory: "no",
    groupField: "no",
    customField: "no",
    customFieldRemark: "no",
    conditionalIds: [],
  },
  {
    type: "score",
    fieldLabel: "Score",
    fieldName: "SCORE",
    fieldReview: "yes",
    fieldLabelType: false,
    fieldDerivation: "no",
    fieldFactor: "no",
    scoreType: "value",
    startScore: 0,
    endScore: 100,
    boxColumn: 10,
    labelBold: true,
    labelItalic: false,
    labelUnderline: false,
    labelColor: "#000000",
    labelSize: 14,
    columnSize: 12,
    manageScore: "no",
    fieldWidthSize: 100,
    inputWidthSize: 100,
    fieldMandatory: "no",
    groupField: "no",
    customField: "no",
    conditionalIds: [],
  },
  {
    type: "textarea",
    fieldLabel: "Textarea",
    fieldPlaceholder: "Enter Text",
    fieldName: "TEXTAREA",
    fieldReview: "yes",
    fieldLabelType: false,
    fieldDerivation: "no",
    fieldFactor: "no",
    labelBold: true,
    labelItalic: false,
    labelUnderline: false,
    labelColor: "#000000",
    labelSize: 14,
    columnSize: 12,
    fieldWidthSize: 100,
    inputWidthSize: 100,
    fieldMandatory: "no",
    groupField: "no",
    customField: "no",
    conditionalIds: [],
  },
  {
    type: "number",
    fieldLabel: "Number",
    fieldPlaceholder: "Enter Number",
    fieldName: "NUMBER",
    fieldUnit: "no",
    fieldReview: "yes",
    fieldLabelType: false,
    autoIncreament: "no",
    conditionalFormKey: "no",
    fieldDerivation: "no",
    fieldFactor: "no",
    labelBold: true,
    labelItalic: false,
    labelUnderline: false,
    labelColor: "#000000",
    labelSize: 14,
    columnSize: 12,
    fieldWidthSize: 100,
    inputWidthSize: 100,
    manageNumberRange: "no",
    fieldMandatory: "no",
    groupField: "no",
    customField: "no",
    numberType: "whole",
    conditionalIds: [],
  },
  {
    type: "radio",
    fieldLabel: "Radio",
    fieldName: "RADIO",
    fieldReview: "yes",
    fieldLabelType: false,
    fieldDerivation: "no",
    fieldFactor: "no",
    labelBold: true,
    labelItalic: false,
    labelUnderline: false,
    labelColor: "#000000",
    labelSize: 14,
    columnSize: 12,
    fieldWidthSize: 100,
    fieldMandatory: "no",
    groupField: "no",
    customField: "no",
    radioVisible: "vertical",
    customFieldRemark: "no",
    conditionalIds: [],
  },
  {
    type: "checkbox",
    fieldLabel: "Checkbox",
    fieldName: "CHECKBOX",
    fieldReview: "yes",
    fieldLabelType: false,
    fieldDerivation: "no",
    fieldFactor: "no",
    labelBold: true,
    labelItalic: false,
    labelUnderline: false,
    labelColor: "#000000",
    labelSize: 14,
    columnSize: 12,
    fieldWidthSize: 100,
    fieldMandatory: "no",
    groupField: "no",
    customField: "no",
    radioVisible: "vertical",
    customFieldRemark: "no",
    conditionalFields: [],
    conditionalIds: [],
  },
  {
    type: "scale",
    fieldLabel: "Scale",
    fieldName: "SCALE",
    fieldReview: "yes",
    fieldLabelType: false,
    fieldDerivation: "no",
    fieldFactor: "no",
    labelBold: true,
    labelItalic: false,
    labelUnderline: false,
    labelColor: "#000000",
    labelSize: 14,
    columnSize: 12,
    fieldWidthSize: 100,
    fieldMandatory: "no",
    groupField: "no",
    customField: "no",
    customFieldRemark: "no",
    conditionalIds: [],
  },
];

const ManageForm = ({
  checkActiveTab,
  checkDynamicActiveTab,
  checkActiveDynamicTabData,
  tableRef,
  onMouseDown,
  activeTabName,
  handleAddNewTab
}) => {
  const [formFields, setFormFields] = useState([]);
  const [formId, setFormId] = useState("");
  const [version, setVersion] = useState("");
  const { toggle, setToggle } = UseToggle();

  const handleFormFieldDelete = (index) => {
    setFormFields((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddFormField = (type) => {
    const template = initialFormFields.find((el) => el.type === type);
    if (template) {
      const newField = {
        ...template,
        id: Math.floor(1000000000 + Math.random() * 9000000000),
      };
      if (type === "heading") {
        newField.fieldName = `HEADING${Math.floor(
          1000000000 + Math.random() * 9000000000
        )}`;
      }
      setFormFields([...formFields, newField]);
    }
  };

  const handleDuplicateFormField = (idToDuplicate) => {
    setFormFields((prevFormFields) => {
      const fieldToDuplicate = prevFormFields.find(
        (el) => el.id === idToDuplicate
      );
      if (!fieldToDuplicate) return prevFormFields;
      const newId = Math.floor(1000000000 + Math.random() * 9000000000);
      const duplicatedField = {
        ...fieldToDuplicate,
        id: newId,
        conditionalIds: [],
        conditionalFields: [],
        ...(fieldToDuplicate.options && {
          options: fieldToDuplicate.options.map((opt) => ({
            ...opt,
            id: Math.floor(1000000000 + Math.random() * 9000000000),
          })),
        }),
        ...(fieldToDuplicate.unitOptions && {
          unitOptions: fieldToDuplicate.unitOptions.map((opt) => ({
            ...opt,
            id: Math.floor(1000000000 + Math.random() * 9000000000),
          })),
        }),
      };
      return [...prevFormFields, duplicatedField];
    });
  };

  const handleUpdateFormField = (id, variable, value, optionId) => {
    setFormFields((prevFields) => {
      let updatedConditionalFields = [];
      if (variable === "conditionalFields") {
        const updatedFields = prevFields.map((field) => {
          if (field.id === id) {
            const currentFieldSelected = field.conditionalFields || [];
            updatedConditionalFields = currentFieldSelected.includes(
              `${value}_${optionId}`
            )
              ? currentFieldSelected.filter(
                (itemId) => itemId !== `${value}_${optionId}`
              )
              : [...currentFieldSelected, `${value}_${optionId}`];

            return {
              ...field,
              conditionalFields: updatedConditionalFields,
            };
          }
          return field;
        });
        return updatedFields.map((field) => {
          if (field.id === value) {
            const currentOptionSelected = field.conditionalIds || [];
            const hasFilterConditionId = updatedConditionalFields.some(
              (item) => item === `${value}_${optionId}`
            );
            return {
              ...field,
              conditionalIds: !hasFilterConditionId
                ? currentOptionSelected.filter((itemId) => itemId !== optionId)
                : [...new Set([...currentOptionSelected, optionId])],
            };
          }
          return field;
        });
      }
      if (variable === "selectAllconditionalFields") {
        const updatedFields = prevFields.map((field) => {
          if (field.id === id) {
            const allIds = (
              getFieldsUsedInConditionalFields(value, field) || []
            ).map((item) => `${item.id}_${optionId}`);
            const currentFieldSelected = field.conditionalFields || [];
            const hasMatchId = currentFieldSelected.some(
              (item) => item.split("_")[1] === String(optionId)
            );
            const hasFilterId =
              currentFieldSelected.filter(
                (item) => item.split("_")[1] === String(optionId)
              )?.length === allIds?.length;
            const allSelected = currentFieldSelected.filter(
              (item) => item.split("_")[1] !== String(optionId)
            );
            const allUpdatedId = [...allSelected, ...allIds];
            updatedConditionalFields =
              hasMatchId && hasFilterId ? allSelected : allUpdatedId;
            return {
              ...field,
              conditionalFields: [...new Set(updatedConditionalFields)],
            };
          }
          return field;
        });
        return updatedFields.map((field) => {
          if (field.id !== id) {
            const currentOptionSelected = field.conditionalIds || [];
            const hasFilterId = updatedConditionalFields.filter(
              (item) => item.split("_")[1] === String(optionId)
            );
            return {
              ...field,
              conditionalIds:
                hasFilterId?.length === 0
                  ? currentOptionSelected?.filter((id) => id !== optionId)
                  : [...new Set([...currentOptionSelected, optionId])],
            };
          }
          return field;
        });
      }
      return prevFields.map((field) =>
        field.id === id ? { ...field, [variable]: value } : field
      );
    });
  };

  const getFieldsUsedInConditionalFields = (fields, fieldData) => {
    return fields
      .map((field) => {
        if (
          ![
            ...new Set(
              field?.conditionalFields?.map((fieldId) =>
                Number(fieldId.split("_")[0])
              )
            ),
          ]?.includes(fieldData.id)
        ) {
          return {
            id: field?.id,
          };
        }
      })
      .filter(Boolean);
  };

  return (
    <>
      {checkActiveTab("viewFormLists") ? (
        <ViewFormList
          setFormFields={setFormFields}
          formFields={formFields}
          formId={formId}
          setFormId={setFormId}
          version={version}
          setVersion={setVersion}
        />
      ) : checkActiveTab("viewFormReportLists") ? (
        <ViewFormReportList
          setFormFields={setFormFields}
          formFields={formFields}
          formId={formId}
          setFormId={setFormId}
          version={version}
          setVersion={setVersion}
        />
      ) : checkActiveTab("editFormFields") ? (
        <FormEditor
          setFormFields={setFormFields}
          formFields={formFields}
          handleFormFieldDelete={handleFormFieldDelete}
          handleUpdateFormField={handleUpdateFormField}
          handleDuplicateFormField={handleDuplicateFormField}
          handleAddFormField={handleAddFormField}
          formId={formId}
          setFormId={setFormId}
          version={version}
          setVersion={setVersion}
          setToggleLibrary={setToggle}
          toggleLibrary={toggle}
        />
      ) : checkDynamicActiveTab("viewEventSchemaFormLists") ? (
        <FormDataEntry
          activeTabName={checkActiveDynamicTabData("viewEventSchemaFormLists")?.idObject}
          tableRef={tableRef}
          onMouseDown={onMouseDown}
          handleAddNewTab={handleAddNewTab}
        />
      ) : (
        checkActiveTab("manageGlobalFormFieldLibrary") && (
          <FormFieldLibraryEditor
            setFormFields={setFormFields}
            formFields={formFields}
            handleFormFieldDelete={handleFormFieldDelete}
            handleUpdateFormField={handleUpdateFormField}
            handleDuplicateFormField={handleDuplicateFormField}
            handleAddFormField={handleAddFormField}
            categoryId={formId}
            setCategoryId={setFormId}
          />
        )
      )}
    </>
  );
};

export default ManageForm;
